import * as v from "valibot";

// request — GET with ProductTypeId as query param; body is empty
export const RequestSchema = v.object({});
export type Request = v.InferOutput<typeof RequestSchema>;

// response
export const DataSchema = v.nullable(v.array(v.string()));

export type Data = v.InferOutput<typeof DataSchema>;

export const ResponseSchema = v.object({
  Data: DataSchema,
  RequestId: v.string(),
});

export type Response = v.InferOutput<typeof ResponseSchema>;
